'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Position = require('../Position/Position');

var _Position2 = _interopRequireDefault(_Position);

var _PositionSource = require('../Position/PositionSource');

var _PositionSource2 = _interopRequireDefault(_PositionSource);

var _PositionTarget = require('../Position/PositionTarget');

var _PositionTarget2 = _interopRequireDefault(_PositionTarget);

var _TooltipContent = require('../Tooltip/TooltipContent');

var _TooltipContent2 = _interopRequireDefault(_TooltipContent);

var _TooltipContext = require('../Tooltip/TooltipContext');

var _TooltipContext2 = _interopRequireDefault(_TooltipContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Handle = function (_Component) {
  _inherits(Handle, _Component);

  function Handle() {
    _classCallCheck(this, Handle);

    return _possibleConstructorReturn(this, (Handle.__proto__ || Object.getPrototypeOf(Handle)).apply(this, arguments));
  }

  _createClass(Handle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          onMouseDown = _props.onMouseDown,
          isVisible = _props.isVisible,
          value = _props.value,
          valueAsPercentage = _props.valueAsPercentage,
          valueFormatter = _props.valueFormatter,
          withTooltip = _props.withTooltip,
          size = _props.size;

      var setSize = size ? { width: size + 'px', height: size + 'px' } : {};

      return _react2.default.createElement(
        _Position2.default,
        {
          enabled: withTooltip,
          isVisible: isVisible,
          showArrow: true },
        _react2.default.createElement(
          _PositionTarget2.default,
          null,
          _react2.default.createElement('div', {
            className: 'ax-slider__thumb',
            onMouseDown: disabled ? null : onMouseDown,
            style: _extends({ left: valueAsPercentage + '%' }, setSize) })
        ),
        _react2.default.createElement(
          _PositionSource2.default,
          null,
          _react2.default.createElement(
            _TooltipContext2.default,
            { theme: 'night', width: 'auto' },
            _react2.default.createElement(
              _TooltipContent2.default,
              { size: 'tiny', textStrong: true },
              valueFormatter(value)
            )
          )
        )
      );
    }
  }]);

  return Handle;
}(_react.Component);

Handle.propTypes = {
  /** Disabled control of the Handle */
  disabled: _propTypes2.default.bool,
  /** Visibility of the Handle */
  isVisible: _propTypes2.default.bool,
  /** Callback for when the mouse is down **/
  onMouseDown: _propTypes2.default.func,
  /** The width and height of the handle **/
  size: _propTypes2.default.number,
  /** Value for the tooltip content */
  value: _propTypes2.default.number,
  /** Value for the Handle position */
  valueAsPercentage: _propTypes2.default.number,
  /** Value formatter for the tooltip */
  valueFormatter: _propTypes2.default.func,
  /** Enables a value indicating tooltip */
  withTooltip: _propTypes2.default.bool
};
Handle.defaultProps = {
  disabled: false,
  isVisible: true,
  onMouseDown: function onMouseDown() {},
  valueFormatter: function valueFormatter(n) {
    return n;
  },
  withTooltip: false
};
exports.default = Handle;